import React from 'react';
import { ISVGType } from './SVGType';

const CrossToastIcon = (props: ISVGType) => {
  const { height = 10, width = 9, color= "#A0A0A0" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 9 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.24264 6.24264L1.41422 9.07107L7.7486e-06 7.65685L2.82843 4.82843L0 2L1.41422 0.585785L4.24265 3.41422L7.07108 0.585785L8.48529 2L5.65686 4.82843L8.48528 7.65685L7.07107 9.07107L4.24264 6.24264Z"
        fill={color}
      />
    </svg>
  );
};

export default CrossToastIcon;
